var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeclined = function SvgDeclined(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6673 7.99967C14.6673 11.6816 11.6826 14.6663 8.00065 14.6663C4.31875 14.6663 1.33398 11.6816 1.33398 7.99967C1.33398 4.31778 4.31875 1.33301 8.00065 1.33301C11.6826 1.33301 14.6673 4.31778 14.6673 7.99967ZM10.2398 10.2388C10.0446 10.4341 9.72799 10.4341 9.53272 10.2388L8.00066 8.70674L6.46858 10.2388C6.27332 10.4341 5.95674 10.4341 5.76148 10.2388C5.56622 10.0436 5.56622 9.72697 5.76148 9.53171L7.29355 7.99963L5.76149 6.46757C5.56623 6.27231 5.56623 5.95573 5.76149 5.76046C5.95675 5.5652 6.27333 5.5652 6.46859 5.76046L8.00066 7.29253L9.53271 5.76047C9.72798 5.56521 10.0446 5.56521 10.2398 5.76047C10.4351 5.95573 10.4351 6.27232 10.2398 6.46758L8.70776 7.99963L10.2398 9.5317C10.4351 9.72696 10.4351 10.0435 10.2398 10.2388Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeclined);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "declined.cf590874c1bdd116d1c28fdd043e875e.svg";